/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIContractStatusEnum } from './APIContractStatusEnum';
import {
    APIContractStatusEnumFromJSON,
    APIContractStatusEnumFromJSONTyped,
    APIContractStatusEnumToJSON,
} from './APIContractStatusEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIContractRequest
 */
export interface APIContractRequest {
    /**
     * 
     * @type {string}
     * @memberof APIContractRequest
     */
    offer: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIContractRequest
     */
    editors?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIContractRequest
     */
    shippingAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContractRequest
     */
    billingAddress?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIContractRequest
     */
    desiredDelivery?: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIContractRequest
     */
    latestDelivery?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof APIContractRequest
     */
    priorityShipping?: boolean;
    /**
     * 
     * @type {APIContractStatusEnum}
     * @memberof APIContractRequest
     */
    contractStatus?: APIContractStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof APIContractRequest
     */
    comment?: string | null;
    /**
     * Price that gets selected by the user from the Prices of the Offer. Format: {'200': '123.45'}
     * @type {{ [key: string]: any; }}
     * @memberof APIContractRequest
     */
    price?: { [key: string]: any; };
}



/**
 * Check if a given object implements the APIContractRequest interface.
 */
export function instanceOfAPIContractRequest(value: object): value is APIContractRequest {
    if (!('offer' in value) || value['offer'] === undefined) return false;
    return true;
}

export function APIContractRequestFromJSON(json: any): APIContractRequest {
    return APIContractRequestFromJSONTyped(json, false);
}

export function APIContractRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContractRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'offer': json['offer'],
        'editors': json['editors'] == null ? undefined : json['editors'],
        'shippingAddress': json['shipping_address'] == null ? undefined : json['shipping_address'],
        'billingAddress': json['billing_address'] == null ? undefined : json['billing_address'],
        'desiredDelivery': json['desired_delivery'] == null ? undefined : (new Date(json['desired_delivery'])),
        'latestDelivery': json['latest_delivery'] == null ? undefined : (new Date(json['latest_delivery'])),
        'priorityShipping': json['priority_shipping'] == null ? undefined : json['priority_shipping'],
        'contractStatus': json['contract_status'] == null ? undefined : APIContractStatusEnumFromJSON(json['contract_status']),
        'comment': json['comment'] == null ? undefined : json['comment'],
        'price': json['price'] == null ? undefined : json['price'],
    };
}

export function APIContractRequestToJSON(value?: APIContractRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'offer': value['offer'],
        'editors': value['editors'],
        'shipping_address': value['shippingAddress'],
        'billing_address': value['billingAddress'],
        'desired_delivery': value['desiredDelivery'] == null ? undefined : ((value['desiredDelivery']).toISOString()),
        'latest_delivery': value['latestDelivery'] == null ? undefined : ((value['latestDelivery']).toISOString()),
        'priority_shipping': value['priorityShipping'],
        'contract_status': APIContractStatusEnumToJSON(value['contractStatus']),
        'comment': value['comment'],
        'price': value['price'],
    };
}

